import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SentryErrorBoundary"] */ "/opt/buildhome/repo/components/SentryErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/styles/globals.css");
